import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../icons/Icon';

export default ({ headerText, imageLocation, name, onClose }) => (
  <div className="ms__request__confirmation">
    {imageLocation ? (
      <div className="ms__request-img" style={{ backgroundImage: `url(${imageLocation})` }} />
    ) : (
      <Icon icon="Tathata-Logo-Check" />
    )}
    <h4>{headerText}</h4>
    <p>
      You can view your follow-ups on your <Link to="/subscription/follow-ups">follow-ups page</Link>.
    </p>
    <button type="button" className="button button--theme--outline" onClick={onClose}>
      Close
    </button>
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/session-requests/SessionRequestSuccess.js